import type { BestTimeDef } from '@/lib/best-time-pages';
import { uiFb } from '@/lib/i18n';
import { getMonthName } from '@/lib/constants';
import { LevelBadge } from './LevelBadge';

interface SeasonOverviewGridProps {
  seasons: BestTimeDef['seasons'];
  lang: string;
}

export function SeasonOverviewGrid({ seasons, lang }: SeasonOverviewGridProps) {
  return (
    <div className="mb-8 border-t border-border-subtle pt-6">
      <h2 className="font-heading text-xl font-bold text-text-primary md:text-2xl">
        {uiFb('ui.season_overview', 'Season Overview', lang)}
      </h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {seasons.map(season => (
          <div
            key={season.name}
            className="content-card p-4"
          >
            <h3 className="text-sm font-semibold text-text-primary">{season.name}</h3>
            <p className="mt-1 text-xs text-text-secondary">
              {season.months.map(m => getMonthName(m - 1, lang).slice(0, 3)).join(', ')}
            </p>
            <div className="mt-3 space-y-1.5 text-xs">
              <div className="flex justify-between">
                <span className="text-text-secondary">{uiFb('ui.temperature', 'Temperature', lang)}</span>
                <span className="font-medium text-text-primary">{season.tempRange}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-text-secondary">{uiFb('ui.weather', 'Weather', lang)}</span>
                <span className="font-medium text-text-primary">{season.weather}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-text-secondary">{uiFb('ui.crowds', 'Crowds', lang)}</span>
                <LevelBadge level={season.crowds} variant="chip" />
              </div>
              <div className="flex justify-between">
                <span className="text-text-secondary">{uiFb('ui.prices', 'Prices', lang)}</span>
                <LevelBadge level={season.prices} variant="chip" />
              </div>
            </div>
            <p className="mt-3 text-xs leading-relaxed text-text-secondary">{season.verdict}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
